import * as React from "react";
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import { FormGroup, FormControl } from "react-bootstrap";

export class ModalGestionTraslado extends React.Component<ModalGestionTrasladoProps, any> {

    constructor(props: any) {
        super(props);

        this.state = {
            show: true,
            observacion: ''
        };
    }

    handleShow() {
        this.setState({ show: true });
    }

    handleClose() {
        this.setState({ show: false });
        this.props.cerrarModal();
    }

    render() {
        return (
            <div>
                {this.renderModalGestion()}
            </div>
        );
    }

    renderModalGestion() {
        const btnAcciones = [
            (
                <FlatButton key={1}
                    label={this.props.botonEnviar}
                    disabled={!this.state.observacion}
                    onClick={() => {
                        this.handleClose();
                        this.props.observacionGestion(this.state.observacion);
                    }}
                />
            ), (
                <FlatButton key={0}
                    label="Cerrar"
                    onClick={() => this.handleClose()} />
            )
        ];
        return (
            <div>
                <Dialog title={"Gestión de Empresas"}
                    actions={btnAcciones}
                    contentStyle={{ width: '40%', maxWidth: 'none' }}
                    open={this.state.show}
                    onRequestClose={() => this.handleClose()}
                    modal={false}>
                    {this.renderContenidoGestion()}
                </Dialog>
            </div>
        );
    }

    renderContenidoGestion() {
        return (
            <div>
                <div className="modal-form-text info-col" style={{ marginBottom: '25px' }}>
                    <span>
                        La gestión se realizara para {this.props.cantidadSeleccionados} registros seleccionados.
                    </span>
                </div>
                <FormGroup controlId="formControlsTextarea" validationState={this.getValidationState()}>
                    <FormControl
                        value={this.state.observacion}
                        onChange={e => this.setState({ observacion: e.target.value })}
                        componentClass="textarea"
                        placeholder="Observación"
                        style={{ height: 130 }} maxLength={256}
                    />
                </FormGroup>
            </div>
        );
    }

    getValidationState() {
        const length = this.state.observacion.length;
        if (length > 0) return 'success';
        if (length === 0) return 'error';
        return null;
    }
}

interface ModalGestionTrasladoProps {
    botonEnviar: string,
    cantidadSeleccionados: number,
    cerrarModal: () => void,
    observacionGestion: (observacion: string) => void
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/gestion_empresas_trasladables/componentes/ModalGestionTraslado.tsx